import React from 'react';
import styled from 'styled-components/macro';

import DinteroLogo from './icons/dintero-white.svg';
import { distances } from '../../styles/constants';

const AppBarDinteroLogo = () => {
    return <Centered><AppBarLogoImage src={DinteroLogo} /></Centered>;
};

const AppBarLogoImage = styled.img`
    margin-top: 16px;
    margin-bottom: 16px;
    width: 120px;
`;


const Centered = styled.div`
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        position: fixed;
        top: 4px;
        left: ${distances.small};
        right: unset;
    }
`;
export default AppBarDinteroLogo;
